import Label from '../../../../ui/label'
import { useDispatch } from 'react-redux'
import { resetUniformCoverage } from '../../../../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.slice'
import { resetLevelRanking } from '../../../../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.slice'
import { resetSalaryRank } from '../../../../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.slice'
import { resetAmountOfLoans } from '../../../../../features/gms-proposal-forms/amount-of-loans/amount-loans.slice'
import { resetSelectedRiders } from '../../../../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice'
import LoadingCategory from '../../../../ui/loading-category'
import ErrorFetch from '../../../../ui/error-fetch-category'
import { useMemo } from 'react'
import { useQueries } from '../../../../../hooks/services/queries/use-queries'
import { PRODUCT_TYPE_IDS } from '../../../../../constant/gms-constant'
import { resetCoverageType, setSelectedBasicPlansBox, setSelectedProductTypeBox } from '../../../../../features/gms-proposal-forms/types-proposal-product-basic-plan/types-proposal-product-basic-plan-slice'
import { resetBorrowerAge, resetBorrowerAgeOptions, setBorrowerAgeIsShow } from '../../../../../features/gms-proposal-forms/age-bracket-and-benefit-amount/age-bracket-and-benefit-amount.slice'
import { resetLoanMaturityType, setSelectedPaymentTermBox } from '../../../../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice'
import { SubTypeOption } from '../../../../../api/gms/group-category/group-category-api-state'
import Checkbox from '../../../../ui/checkbox'
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data'
import { useCreateProposalForm } from '../../../../../hooks/actions/use-create-proposal-form'

export default function ClientInputProductTypes() {

    const dispatch = useDispatch()
    const { 
        typeOfProduct, 
        isLoadingTypeOfProduct, 
        isErrorTypeOfProduct 
    } = useQueries()
    const {
        existingCompany
    } =  useCreateProposalForm()
    const { product } = useProposalTypeData()
    const isErrorLoading = isErrorTypeOfProduct || isLoadingTypeOfProduct

    const handleChangeProductType = (e: React.ChangeEvent<HTMLInputElement>, option: SubTypeOption) => {
        dispatch(setSelectedProductTypeBox(option));
        // dispatch(setPlansAndRidersByProposalType(option.id));
        dispatch(setSelectedBasicPlansBox(null))
        dispatch(resetAmountOfLoans())
        dispatch(resetCoverageType())
        dispatch(resetLevelRanking())
        dispatch(resetUniformCoverage())
        dispatch(resetSalaryRank())
        dispatch(resetSelectedRiders())
        // RESET PAYMENT TERM
        dispatch(setSelectedPaymentTermBox(null))
        // RESET LOAN MATURITY
        dispatch(resetLoanMaturityType())
        // RESET BORROWER AGE
        dispatch(resetBorrowerAge())
        // RESET BENEFIT AMOUNT AND RATE
        dispatch(resetBorrowerAgeOptions())

        if (option.id === PRODUCT_TYPE_IDS.GCI) {
            dispatch(setBorrowerAgeIsShow({ id: 6, isShow: true }))
            dispatch(setBorrowerAgeIsShow({ id: 3, isShow: false }))
            dispatch(setBorrowerAgeIsShow({ id: 4, isShow: false }))
            dispatch(setBorrowerAgeIsShow({ id: 5, isShow: false }))
        } else {
            dispatch(setBorrowerAgeIsShow({ id: 6, isShow: false }))
            dispatch(setBorrowerAgeIsShow({ id: 3, isShow: true }))
            dispatch(setBorrowerAgeIsShow({ id: 4, isShow: true }))
            dispatch(setBorrowerAgeIsShow({ id: 5, isShow: true }))
        }
    };

    const mappedOptions: SubTypeOption[] = useMemo(() =>
            typeOfProduct?.map(item => ({
                id: item.product_id,
                name: item.product_name
            })) || [],
        [typeOfProduct]
    );

    return (
        <div className='space-y-2'>
            <Label
                label='Type of Product'
                fontWeight="font-semibold text-gray-800"
                fontSize="text-xs"
                requiredText=' *'
                isRequired={true}
            />
            <div className={`grid ${isErrorLoading ? 'grid-cols-1' : 'grid-cols-1'} gap-2`}>
                {isLoadingTypeOfProduct ? (
                    <LoadingCategory />
                ) : isErrorTypeOfProduct ? (
                    <ErrorFetch />
                ) : (
                    mappedOptions.map(option => {
                        const existingProducts = existingCompany?.data.product ?? [];
                        const selectedProduct = existingProducts.some(item => item.product.id === option.id);
                        const isSelected = product?.name === option.name
                        return (
                            <Checkbox
                                key={option.id}
                                disabled={selectedProduct} 
                                option={option} 
                                isSelected={isSelected} 
                                onChange={handleChangeProductType}
                            />
                        )
                    })
                )}
            </div>
        </div>
    )
}